import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../services/user.service';

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (!userService.isAuthenticated()) {
    // Store the intended URL
    sessionStorage.setItem('redirectUrl', state.url);
    userService.redirectUrl = state.url;

    router.navigate(['/login']);
    return false;
  }

  if (userService.isAdmin() && !userService.isImpersonating()) {
    window.location.replace('/Admin');
    return false;
  }

  return true;
};